export function formatFullName(
  firstName?: string | null,
  lastName?: string | null,
  fallback = "Unnamed",
): string {
  return [firstName, lastName].filter(Boolean).join(" ").trim() || fallback;
}

export function safeNumber(value: unknown, fallback = 0): number {
  if (value === null || value === undefined) return fallback;
  const num = Number(value);
  return Number.isNaN(num) || !Number.isFinite(num) ? fallback : num;
}

export function safeJsonParse<T = Record<string, unknown>>(
  input: string,
  fallback: T = {} as T,
): T {
  try {
    return JSON.parse(input) as T;
  } catch {
    return fallback;
  }
}
